import { getAnonymousId, identify } from "./analytics";

const wait = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

/**
 * RetrieveAnonymousId does it's best effort to get an anonymous ID from Segment. First
 * it tries to pull it and if it does returns.  If it doesn't exist because we don't have
 * an identity it calls identify with nothing to generate a random segment id UUID-v4 and returns
 * that.  If that still doesn't work it returns nothing and moves on logging a debug message
 * letting us know we actually tried.
 */
// Pure functions - no side effects, only data retrieval/generation
export async function retrieveAnonymousId(): Promise<string> {
  // Try to get existing anonymous ID
  let anonymousId = getAnonymousId();
  if (anonymousId) {
    return anonymousId;
  }

  // If we don't have an anonymousId, initialize the analytics object to generate a segment anonymousId
  await identify({});
  // Give analytics time to load otherwise we might not have the analytics ID set
  await wait(300);
  anonymousId = getAnonymousId();
  // This can still fail but that's okay, we just return an empty string.
  console.debug("Anonymous ID not available, returning empty string");
  return anonymousId;
}
